import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
	'use strict';

	angular
        .module('riskSelfAssessmentReviewControllers')
        .factory('riskSelfAssessmentReviewService', service);

	service.$inject = ['$http', '$q', 'env'];

	function service($http, $q, env) {
	    var baseUrl = environment.apiUrl + '/Pilot/api/RiskSelfAssessment';
		var baseReportUrl = environment.apiUrl + '/ReportPilot/api/RiskSelfAssessment';

	    var service = {
	        cancelReviewRisk:                       cancelReviewRisk,
	        getTopRisksToReview:                    getTopRisksToReview,
	        getKeyRisksToReviewByTopRisk:           getKeyRisksToReviewByTopRisk,
	        updateKeyRiskPreFinalAssessment:        updateKeyRiskPreFinalAssessment,
	        confirmPreFinalChangesOnRiskAssessment: confirmPreFinalChangesOnRiskAssessment,
	        discardPreFinalChangesOnRiskAssessment: discardPreFinalChangesOnRiskAssessment,
	        resetFinalChangesOnRiskAssessment:      resetFinalChangesOnRiskAssessment,
	        getTopOrKeyRisksToReview:               getTopOrKeyRisksToReview,
	        getRisksToReview:                       getRisksToReview,
	        getRiskToReview:                        getRiskToReview,
	        reviewRiskByAssessor:                   reviewRiskByAssessor,
			getRiskEvents:                          getRiskEvents,
			summaryExportToExcel:                   summaryExportToExcel,
			summaryExportToRepor:                   summaryExportToReport
		};
		return service;

		////////////

	    // Cancel Review Risk
		function cancelReviewRisk(riskToReview) {
		    var reqUrl = baseUrl + '/Risk/' + riskToReview.Risk.RiskID + '/Review/Cancel';

		    return $http.post(reqUrl, riskToReview)
                        .then(function (response) {
                            return response.data;
                        });
		}

	    // Get Top Risks To Review
		function getTopRisksToReview() {
		    var reqUrl = baseUrl + '/Risk/Top/Review';

		    return $http.get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}

	    // Get Key Risks To Review By Top Risk
		function getKeyRisksToReviewByTopRisk(topRiskId) {
		    var reqUrl = baseUrl + '/Risk/' + topRiskId + '/Key/Review';

		    return $http.get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}

	    // Update Key Risk PreFinal Assessment
		function updateKeyRiskPreFinalAssessment(riskToReview) {
		    var reqUrl = baseUrl + '/Risk/' + riskToReview.Risk.RiskID + '/Review/Key/Update';

		    return $http.post(reqUrl, riskToReview)
                        .then(function (response) {
                            return response.data;
                        });
		}

	    // Confirm PreFinal Changes on Risk Assessment
		function confirmPreFinalChangesOnRiskAssessment(riskToReview) {
		    var reqUrl = baseUrl + '/Risk/' + riskToReview.Risk.RiskID + '/Review/Confirm';

		    return $http.post(reqUrl, riskToReview)
                        .then(function (response) {
                            return response.data;
                        });
		}

	    // Discard PreFinal Changes On RiskAssessment
		function discardPreFinalChangesOnRiskAssessment(riskToReview) {
		    var reqUrl = baseUrl + '/Risk/' + riskToReview.Risk.RiskID + '/Review/Discard';

		    return $http.post(reqUrl, riskToReview)
                        .then(function (response) {
                            return response.data;
                        });
		}

	    // Reset Final Changes On RiskAssessment
		function resetFinalChangesOnRiskAssessment(riskToReview) {
		    var reqUrl = baseUrl + '/Risk/' + riskToReview.Risk.RiskID + '/Review/Reset';

		    return $http.post(reqUrl, riskToReview)
                        .then(function (response) {
                            return response.data;
                        });
		}

	    // Get Top or Key Risks To Review
		function getTopOrKeyRisksToReview() {
		    var reqUrl = baseUrl + '/Risk/TopOrKey/Review';

		    return $http.get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}

	    // Get Risks to Review by Assessor
		function getRisksToReview(assessorId) {
		    var reqUrl = baseUrl + '/Assessor@' + assessorId;

		    return $http.get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}

	    // Get Risk to Review
		function getRiskToReview(riskId) {
		    var reqUrl = baseUrl + '/Risk/' + riskId + '/Review';

		    return $http.get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}

        // Review Risk by Assessor
		function reviewRiskByAssessor(riskToReview) {
		    var reqUrl = baseUrl + '/Risk/' + riskToReview.Risk.RiskID + '/Review';

		    return $http.post(reqUrl, riskToReview)
                        .then(function (response) {
                            return response.data;
                        });
		}

		// Risk Events
		function getRiskEvents(risk) {
			var url = environment.apiUrl + '/Pilot/api/Risk/' + risk.RiskID + '/RiskEvent';
			return $http.get(url)
				.then(function (response) {
					return response.data;
				});
		}

	    // Summary Export To Excel
		function summaryExportToExcel(assessorId) {
		    var reqUrl = baseReportUrl + '/Assessor@' + assessorId + '/Review/SummaryExportToExcel';

		    return $http.post(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}

	    // Summary Export To Report
		function summaryExportToReport(assessorId) {
		    var reqUrl = baseReportUrl + '/Assessor@' + assessorId + '/Review/SummaryExportToReport';

		    return $http.post(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}
	}
})();
